import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["variant"];
import React from 'react';
import Box from '../Box';
import Text from '../Text';
import PropTypes from 'prop-types';
import { useThemeDefaults } from '../utils';
export var SINGLE = 'single';
export var MULTI = 'multi';

var isMultiVariant = function isMultiVariant(variant) {
  return variant === MULTI;
};

var MetricHeaderVariantContext = /*#__PURE__*/React.createContext(SINGLE);
export var withVariant = function withVariant(Component) {
  return /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(MetricHeaderVariantContext.Consumer, null, function (variant) {
      return /*#__PURE__*/React.createElement(Component, _extends({
        variant: variant
      }, props, {
        ref: ref
      }));
    });
  });
};
export var Container = useThemeDefaults(function (_ref) {
  var theme = _ref.theme;
  return {
    display: theme.metricHeader.container.display,
    justifyContent: theme.metricHeader.container.justifyContent,
    borderBottom: theme.metricHeader.container.borderBottom,
    borderColor: theme.metricHeader.container.borderColor,
    paddingBottom: theme.metricHeader.container.paddingBottom
  };
}, Box);
export var FlexBox = useThemeDefaults(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: theme.metricHeader.flexBox.display,
    justifyContent: theme.metricHeader.flexBox.justifyContent,
    alignItems: theme.metricHeader.flexBox.alignItems
  };
}, Box);
export var Title = useThemeDefaults(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: theme.metricHeader.title.display,
    textTransform: theme.metricHeader.title.textTransform,
    textStyle: theme.metricHeader.title.textStyle,
    sb: theme.metricHeader.title.spaceBelow
  };
}, Text);
export var Total = withVariant(useThemeDefaults(function (_ref4) {
  var variant = _ref4.variant,
      theme = _ref4.theme;
  return {
    textStyle: isMultiVariant(variant) ? theme.metricHeader.total.multiTextStyle : theme.metricHeader.total.textStyle,
    sb: theme.metricHeader.total.sb
  };
}, Text));
export var Delta = useThemeDefaults(function (_ref5) {
  var theme = _ref5.theme;
  return {
    display: theme.metricHeader.delta.display,
    whiteSpace: theme.metricHeader.delta.whiteSpace,
    textStyle: theme.metricHeader.delta.textStyle,
    color: theme.metricHeader.delta.color,
    ml: theme.metricHeader.delta.ml,
    mr: theme.metricHeader.delta.mr
  };
}, Text);
export var DeltaSubtitle = useThemeDefaults(function (_ref6) {
  var theme = _ref6.theme;
  return {
    whiteSpace: theme.metricHeader.deltaSubtitle.whiteSpace,
    textStyle: theme.metricHeader.deltaSubtitle.textStyle,
    color: theme.metricHeader.deltaSubtitle.color,
    mt: theme.metricHeader.deltaSubtitle.mt,
    mr: theme.metricHeader.deltaSubtitle.mr,
    ml: theme.metricHeader.deltaSubtitle.ml
  };
}, Text);
export var Subtitle = useThemeDefaults(function (_ref7) {
  var theme = _ref7.theme;
  return {
    textStyle: theme.metricHeader.subtitle.textStyle,
    color: theme.metricHeader.subtitle.color,
    mr: theme.metricHeader.subtitle.mr,
    mb: theme.metricHeader.subtitle.mb
  };
}, Text);
export var Divider = useThemeDefaults(function (_ref8) {
  var theme = _ref8.theme;
  return {
    width: theme.metricHeader.divider.width,
    borderLeft: theme.metricHeader.divider.borderLeft,
    borderColor: theme.metricHeader.divider.borderColor,
    mt: theme.metricHeader.divider.mt,
    mr: theme.metricHeader.divider.mr,
    mb: theme.metricHeader.divider.mb
  };
}, Box);
export var MetricHeader = function MetricHeader(_ref9) {
  var _ref9$variant = _ref9.variant,
      variant = _ref9$variant === void 0 ? SINGLE : _ref9$variant,
      props = _objectWithoutProperties(_ref9, _excluded);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MetricHeaderVariantContext.Provider, {
    value: variant
  }, /*#__PURE__*/React.createElement(Container, props)));
};
process.env.NODE_ENV !== "production" ? MetricHeader.propTypes = {
  variant: PropTypes.oneOf(['single', 'multi'])
} : void 0;
MetricHeader.Container = Container;
MetricHeader.FlexBox = FlexBox;
MetricHeader.Title = Title;
MetricHeader.Total = Total;
MetricHeader.Delta = Delta;
MetricHeader.DeltaSubtitle = DeltaSubtitle;
MetricHeader.Subtitle = Subtitle;
MetricHeader.Divider = Divider;
export default MetricHeader;